import { Route } from 'react-router';
import { WeaLocaleProvider } from 'ecCom';
import './css';
import Homepage from './components/Homepage';
import PortalLayout from './components/PortalLayout'
import PortalCom from './components/Homepage';
import PortalSetting from './components/PortalSetting';
import ElementIndie from './components/ElementIndie';
import Synergy from './components/Synergy';
import SynergyPortalSetting from './components/SynergyPortalSetting';
import EPortalBrowser from './elements/components/common/setting_new/content/base/EPortalBrowser';

const getLocaleLabel = WeaLocaleProvider.getLocaleLabel.bind(this, 'portal');

const PortalRoute = (
  <Route ecId={`${(this && this.props && this.props.ecId) || ''}_Route@99e5yn`} path="portal" onEnter={getLocaleLabel}>
    <Route ecId={`${(this && this.props && this.props.ecId) || ''}_Route@97jp4b`} path="portal-:hpid-:subCompanyId" component={Homepage} />
    <Route ecId={`${(this && this.props && this.props.ecId) || ''}_Route@kukeil`} path="layout/:id/:type" component={PortalLayout} />
  </Route>
);

module.exports = {
  Route: PortalRoute,
  store: {},
  Homepage,
  PortalCom,
  PortalSetting,
  ElementIndie,
  Synergy,
  SynergyPortalSetting,
  EPortalBrowser,
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/index.js